import { render, staticRenderFns } from "./fileTable.vue?vue&type=template&id=5b151f2c&scoped=true"
import script from "./fileTable.vue?vue&type=script&lang=js"
export * from "./fileTable.vue?vue&type=script&lang=js"
import style0 from "./fileTable.vue?vue&type=style&index=0&id=5b151f2c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"
import style1 from "./fileTable.vue?vue&type=style&index=1&id=5b151f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b151f2c",
  null
  
)

export default component.exports